// extracted by mini-css-extract-plugin
module.exports = {"overlay":"style_overlay__1HYzq"};